<template v-once>
  <img src="@/assets/icons/onclive_icon.webp" alt="onclive icon">
</template>

<script>
export default {
  name: "Onclive",
};
</script>

<style scoped>
</style>
